import { render, staticRenderFns } from "./PdfImgToDocxPage.vue?vue&type=template&id=b7ae65fe&scoped=true"
import script from "./PdfImgToDocxPage.vue?vue&type=script&lang=ts"
export * from "./PdfImgToDocxPage.vue?vue&type=script&lang=ts"
import style0 from "./PdfImgToDocxPage.vue?vue&type=style&index=0&id=b7ae65fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ae65fe",
  null
  
)

export default component.exports